import { Component, ojs, app, v, each } from "modular-openscriptjs";
import { either, oneOf, uniqueId } from "../../helpers";
import Img from "../Blocks/Img";

const h = app("h");

ojs(Img);

export default class ProductImageView extends Component {
	render(images, ...args) {
		let id = `piv-${uniqueId()}`;

		return h.$(
			h.div(
				{
					id,
					class: "carousel slide",
					style: "margin-left: -1rem; margin-right: -1rem;",
					data_bs_interval: "false",
				},
				either(images.length > 1, () =>
					h.div(
						{ class: "carousel-indicators" },
						each(images, (image, index) =>
							h.button({
								type: "button",
								data_bs_target: `#${id}`,
								data_bs_slide_to: index,
								class:
									either(index == 0, "active", "") +
									" rounded-circle border border-secondary",
								aria_current: "true",
								aria_label: `Slide ${index + 1}`,
								style: `
							width: 5px;
							height: 5px;
						`,
							})
						)
					)
				),

				h.div(
					{ class: "carousel-inner" },
					each(images, (value, index) =>
						h.div(
							{ class: "carousel-item" },
							either(index == 0, { class: "active" }),
							h.img({
								src: value.path,
								class: "d-block w-100 mx-auto rounded-md",
								alt: "image",
								loading: "lazy",
							})
						)
					)
				),
				either(images.length > 1, () => [
					h.button(
						{
							class: "carousel-control-prev",
							type: "button",
							data_bs_target: `#${id}`,
							data_bs_slide: "prev",
						},
						h.span({
							class: "carousel-control-prev-icon bg-black opacity-25 rounded-circle shadow-sm",
							aria_hidden: "true",
						}),
						h.span({ class: "visually-hidden" }, "Previous")
					),
					h.button(
						{
							class: "carousel-control-next",
							type: "button",
							data_bs_target: `#${id}`,
							data_bs_slide: "next",
						},
						h.span({
							class: "bg-black carousel-control-next-icon opacity-25 rounded-circle shadow-sm",
							aria_hidden: "true",
						}),
						h.span({ class: "visually-hidden" }, "Next")
					),
				]),
				...args
			)
		);
	}
}

ojs(ProductImageView);
